import { isAppBridge } from './appStorageMethod';
import chatService from '../service/chatService';
import { NotificationService } from '../service/notifications';

/**
 * Calculates and updates the native app badge count dynamically.
 * It fetches the unread chat messages count and checks for unread system notifications,
 * preventing resetting other notifications (like post likes/comments) to 0.
 */
export const updateAppBadge = async (): Promise<void> => {
    if (typeof window === 'undefined' || !isAppBridge() || !(window as any).appBridge?.badgeMain) {
        return;
    }

    try {
        // 1. Get unread chat count
        const chatUnreadRes = await chatService.getUnreadCount();
        const unreadChatCount = chatUnreadRes?.data?.totalUnreadCount ?? chatUnreadRes?.totalUnreadCount ?? 0;

        // 2. Check if there are other system notifications
        const notiRes = await NotificationService.checkHasNotifications();
        const unreadNotiCount = notiRes?.data?.unreadCount ?? (notiRes?.data?.haveNotification ? 1 : 0);

        // 3. Calculate total badge
        const finalBadge = unreadChatCount + unreadNotiCount;

        // 4. Update native badge
        (window as any).appBridge.badgeMain(finalBadge);
        console.log(`[badgeHelper] App badge updated to: ${finalBadge} (chat: ${unreadChatCount}, system: ${unreadNotiCount})`);
    } catch (error) {
        console.error('Error updating app badge:', error);
    }
};
